import type { ComponentProps } from "react";

import { MAIN_ID } from "@/components/main-id";
import { cn } from "@/lib/utils";

/**
 * The page's one `<main>` landmark, and the target of the skip link. tabIndex -1 lets the skip link move
 * keyboard focus here (the next Tab then starts inside the content); it is not a tab stop and draws no ring.
 */
export function Main({ className, ...props }: Omit<ComponentProps<"main">, "id" | "tabIndex">) {
    return <main id={MAIN_ID} tabIndex={-1} className={cn("focus:outline-none", className)} {...props} />;
}

export default Main;
